export class SystemClock {
    now() {
        return Date.now();
    }
}
export class MockClock {
    constructor() {
        this._time = 0;
    }
    now() {
        return this._time;
    }
    advance(ms) {
        this._time += ms;
    }
    reset() {
        this._time = 0;
    }
}
